
/* eslint-disable */
import React, { useState, useEffect, useContext, useCallback } from 'react'
import Box from '@mui/material/Box'
import { makeStyles } from '@mui/styles'

import { SideNavigation } from 'apps/common/SideNavigation'
import { MobileHeader } from 'apps/common/MobileHeader'
import Header from 'apps/common/Header'
import theme from 'theme'
import { Footer } from 'apps/common/FooterMain'
import { ScreenContext } from 'apps/utils/ScreenContext'

const useStyles = makeStyles(() => ({
	wrapper: {
		[theme.breakpoints.up('tablet')]: {
			marginTop: '0',
		},
		[theme.breakpoints.up('laptop')]: {
			backgroundColor: 'var(--bg)',
		},
	},
}))

const Wrapper = ( {
		children,
		footerNavClassName,
} ) => {
	const classes = useStyles()
	const { isTablet, isLandscape } = useContext( ScreenContext )

	const [ isMenuShown, setIsMenuShown ] = useState(false)

	useEffect(() => {
		if (isTablet) {
			setIsMenuShown(true)
		} else {
			setIsMenuShown(false)
		}
	}, [ isTablet ])

	const toggleMenu = useCallback( () => {
		setIsMenuShown(!isMenuShown )
	}, [ isMenuShown, setIsMenuShown ] )

	return (
		<React.Fragment>
			<Box
				height='100%'
				position='relative'
				display='flex'
				flexDirection='column'
				flex='1'
				// marginLeft={marginLeft}
			>
				<Box
					display='flex'
					flexDirection='column'
				>
					<Box
						maxWidth='100%'
						padding='0'
						display={isTablet ? 'grid !important' : 'flex'}
						gridTemplateColumns={isTablet ? '63px 1fr' : 'auto'}
						flexDirection='row !important'
						borderBottom='1px solid var(--line)'
						flex='1'
					>
						{ isTablet && <SideNavigation isMenuShown={ isMenuShown } /> }
						{ isTablet ?
							<Header /> :
							<MobileHeader
								toggleMenu={ toggleMenu }
								isMenuShown={ isMenuShown }
							/>
						}
						<Box
							className={ classes.wrapper }
							flex='1'
							display='flex'
							flexDirection='column'
							// Clears the fixed Header strip exactly. The breadcrumb bar
						// renders no crumbs any more (routes carry no names), so it is
						// just 10px + 10px padding + 1px border = 21px; the old 42px
						// left a 21px hole under the header line on every page.
						marginTop={ isTablet ? '21px' : '94px' }
						>
							{ children }
						</Box>
					</Box>
					<Footer
						isTablet={ isTablet }
						isLandscape={ isLandscape }
						navClassName={ footerNavClassName }
					/>
				</Box>
			</Box>
		</React.Fragment>
	)
}

export default React.memo(Wrapper)